import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  course: localStorage.getItem('course')
    ? JSON.parse(localStorage.getItem('course'))
    : null,
};

const courseSlice = createSlice({
  name: 'course',
  initialState,
  reducers: {
    setCourse: (state, action) => {
      state.course = action.payload;
      localStorage.setItem('course', JSON.stringify(action.payload));
    },
  },
});

export const {setCourse } = courseSlice.actions;

export default courseSlice.reducer;
